import { render, staticRenderFns } from "./cancelOrder.vue?vue&type=template&id=6a23c9e6&scoped=true"
import script from "./cancelOrder.vue?vue&type=script&lang=js"
export * from "./cancelOrder.vue?vue&type=script&lang=js"
import style0 from "./cancelOrder.vue?vue&type=style&index=0&id=6a23c9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23c9e6",
  null
  
)

export default component.exports